module.exports = __webpack_public_path__ + "img/pressingKnife3.4554cb48.png";